export const isIndiaCountry = (country?: string | null): boolean => (
  (country || '').trim().toUpperCase() === 'IN'
);
